const prodKey =
    'pk_live_51PaarG2LI99ihWFRzNbMEFTiC2EUQuJkCPJp4SkWggJqS4PMFrrkApKtMLNDgWlW0AntfGAVcmglODDPLIlkPDs500tyPywymE';
const testKey =
    'pk_test_51PaarG2LI99ihWFRSwAkFb55QHnFLqmIBOy7a0eb2GabTXzdJcFGzBZLmxrOD5ClRTfHaLJCZoefYYkqOMtolqIN00VxJzcAj8';

let key = prodKey;
if (import.meta.env.DEV) {
    key = testKey;
}

export const STRIPE_PUBLIC_KEY = key;
